import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import QRCodeGenerator from 'qrcode'
import { PostRequestV2 } from '../../common/api'
import { urls } from '../../common/constants'
import { getNum, getTrackingUrl } from '../../common/helper'
import {
  filterItemsHiddenByTables,
  filterQrLogoHiddenByTables,
  getTablePrintHtml,
  getTopDeductForItem,
  isTableToken,
} from '../../common/ticketTableFormat'
import { paytypes } from "../../common/paymentsMode"

export const getTabLabels = (translations) => {
  const dm = translations?.deliveryMemo || {}
  return [
    dm.pendingDeliveryAtMyBranch || 'Pending Delivery At My Branch',
    dm.pendingOtherDeliveryAtMyBranch || 'Pending Other Delivery At My Branch',
    dm.pendingMyDeliveryAtOtherBranch || 'Pending My Delivery At Other Branch',
  ]
}

const getFilterLabel = (dm, key, fallback) => dm[key] || fallback

export const getTableFilterLabels = (translations, variant = 1) => {
  const dm = translations?.deliveryMemo || {}
  const labels = {
    lrNo: getFilterLabel(dm, 'lrNoDot', 'LR No.'),
    offlineLrNo: getFilterLabel(dm, 'offlineLrNo', 'Offline LR No'),
    payment: getFilterLabel(dm, 'payment', 'Payment'),
    lrDueAmt: getFilterLabel(dm, 'lrDueAmt', 'LR Due Amt.'),
    city: getFilterLabel(dm, 'city', 'City'),
    branch: getFilterLabel(dm, 'branch', 'Branch'),
    receiverName: getFilterLabel(dm, 'receiverName', 'Receiver Name'),
    receiverNo: getFilterLabel(dm, 'receiverNoDot', 'Receiver No.'),
    date: getFilterLabel(dm, 'date', 'Date'),
    challanNo: getFilterLabel(dm, 'challanNo', 'Challan No'),
    noOfUnits: getFilterLabel(dm, 'noOfUnits', 'No of Units'),
    cartage: getFilterLabel(dm, 'cartage', 'Cartage'),
    hamali: getFilterLabel(dm, 'hamali', 'Hamali'),
    opHamali: getFilterLabel(dm, 'opHamali', 'Op. Hamali'),
    charges: getFilterLabel(dm, 'charges', 'Charges'),
    discount: getFilterLabel(dm, 'discount', 'Discount'),
    gst: getFilterLabel(dm, 'gst', 'GST'),
    total: getFilterLabel(dm, 'total', 'Total'),
  }
  if (variant === 1) {
    return [
      [{ name: labels.lrNo, id: 'LRNO', marginB: true }, { name: labels.offlineLrNo, id: 'ManualLRNo' }],
      [{ name: labels.payment, id: 'PaymentType', marginB: true }, { name: labels.lrDueAmt, id: 'TotalDues' }],
      [{ name: labels.city, id: 'SourceCity', marginB: true }, { name: labels.branch, id: 'SourceBranch' }],
      [{ name: labels.city, id: 'DestinationCity', marginB: true }, { name: labels.branch, id: 'DestinationBranch' }],
      [{ name: labels.receiverName, id: 'RecName', marginB: true }, { name: labels.receiverNo, id: 'RecMobileNo' }],
      [{ name: labels.date, id: 'ReceiptDate', marginB: true }, { name: labels.challanNo, id: 'ChallanNo' }],
      { name: labels.noOfUnits, id: 'Units', disabled: false, marginB: true },
      { name: labels.cartage, id: 'CartageAmount', disabled: true },
      { name: labels.hamali, id: 'DeliveryChg', disabled: true },
      { name: labels.opHamali, id: 'OperatorHamaliChg', disabled: true },
      { name: labels.charges, id: 'DemurrageChg', disabled: true },
      { name: labels.discount, id: 'discount', disabled: true },
      { name: labels.gst, id: 'GST', disabled: true },
      { name: labels.total, id: 'total', disabled: true },
    ]
  }
  return [
    { name: labels.lrNo, id: 'LRNO', marginB: true },
    { name: labels.offlineLrNo, id: 'ManualLRNo' },
    { name: labels.payment, id: 'PaymentType', marginB: true },
    { name: labels.lrDueAmt, id: 'TotalDues' },
    { name: labels.city, id: 'SourceCity', marginB: true },
    { name: labels.branch, id: 'SourceBranch' },
    { name: labels.city, id: 'DestinationCity', marginB: true },
    { name: labels.branch, id: 'DestinationBranch' },
    { name: labels.receiverName, id: 'RecName', marginB: true },
    { name: labels.receiverNo, id: 'RecMobileNo' },
    { name: labels.date, id: 'ReceiptDate', marginB: true },
    { name: labels.challanNo, id: 'ChallanNo' },
    { name: labels.noOfUnits, id: 'Units', disabled: false, marginB: true },
    { name: labels.cartage, id: 'CartageAmount', disabled: true },
    { name: labels.hamali, id: 'HamaliCharges', disabled: true },
    { name: labels.opHamali, id: 'OperatorHamaliChg', disabled: true },
    { name: labels.charges, id: 'DemurrageChg', disabled: true },
    { name: labels.discount, id: 'Discount', disabled: true },
    { name: labels.gst, id: 'GST', disabled: true },
    { name: labels.total, id: 'BillAmount', disabled: true },
  ]
}

export const NUMERIC_FILTER_FIELDS = [
  'Units',
  'TotalDues',
  'CartageAmount',
  'AdditionalDeliveryCartage',
  'DeliveryChg',
  'HomeDeliveryChg',
  'HamaliCharges',
  'OperatorHamaliChg',
  'ExtraHamli',
  'DemurrageChg',
  'discount',
  'Discount',
  'GST',
  'DeliveryGST',
  'total',
  'BillAmount',
  'finalAmount',
]

const normalizeFilterText = (value) => (value ?? '').toString().trim().toLowerCase()

export const getMatchRank = (value, filterValue) => {
  if (!filterValue) return 0
  const v = normalizeFilterText(value)
  const f = normalizeFilterText(filterValue)
  if (!f) return 0
  if (!v) return 999
  if (v === f) return 0
  if (v.startsWith(f)) return 1
  const index = v.indexOf(f)
  return index === -1 ? 999 : 2 + index
}

const getFieldCompareValue = (item, field, combinedSender) => {
  if (field === 'Sender' && combinedSender) {
    return normalizeFilterText(`${item.Sender || ''} ${item.SenderMobileNo || ''}`)
  }
  return normalizeFilterText(item[field])
}

export const rankFilteredRows = (rows, filterValues, { combinedSender = false } = {}) => {
  const rankedFields = Object.keys(filterValues).filter(
    (field) => filterValues[field] && !NUMERIC_FILTER_FIELDS.includes(field)
  )
  if (!rankedFields.length) return rows

  const getRowRank = (item) => rankedFields.reduce((total, field) => {
    const filterValue = filterValues[field]
    if (field === 'Sender' && combinedSender) {
      return total + Math.min(getMatchRank(item.Sender, filterValue), getMatchRank(item.SenderMobileNo, filterValue))
    }
    return total + getMatchRank(item[field], filterValue)
  }, 0)

  return [...rows].sort((a, b) => {
    const rankDiff = getRowRank(a) - getRowRank(b)
    if (rankDiff !== 0) return rankDiff
    for (const field of rankedFields) {
      const cmp = getFieldCompareValue(a, field, combinedSender)
        .localeCompare(getFieldCompareValue(b, field, combinedSender))
      if (cmp !== 0) return cmp
    }
    return 0
  })
}

export const getFilterNameMap = (translations) => {
  const dm = translations?.deliveryMemo || {}
  return {
    PaymentType: dm.paymentType || 'Payment Type',
    ChallanNo: dm.challanNoDot || 'Challan No.',
    LRNO: dm.lrNoDot || 'LR No.',
    ManualLRNo: dm.offlineLrNoDot || 'Offline LR No.',
    Sender: dm.sender || 'Sender',
    SenderMobileNo: dm.senderNo || 'Sender No',
    SenderGSTN: dm.senderGstin || 'Sender GSTIN',
    SenderEmailID: dm.senderEmailId || 'Sender Email ID',
    RecName: dm.receiver || 'Receiver',
    RecMobileNo: dm.receiverNo || 'Receiver No',
    ReceiverEmailID: dm.receiverEmailId || 'Receiver Email ID',
    ReceiverGSTN: dm.receiverGstin || 'Receiver GSTIN',
    PinCode: dm.pincode || 'Pincode',
  }
}

export const headCellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '4px 6px 4px 6px',
  color: '#fff',
  fontFamily: 'Roboto',
  fontWeight: 600,
}

export const cellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '6px',
  fontFamily: 'Roboto',
  // fontWeight: 500,
  color: '#444444'
}
export const excelHeadCellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '4px 6px 4px 6px',
  color: '#444444',
  fontFamily: 'Roboto',
  fontWeight: 600,
}
export const excelCellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '6px',
  fontFamily: 'Roboto',
  color: '#444444',
  fontSize: '16px'
}
export const transparentStyle = (theme) => ({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  marginRight: '0',
  color: theme.palette.primary.main,
  fontWeight: 'bold',
})

export const paymentTypeStyles = {
  padding: '4px 9px',
  fontSize: '12px',
  borderRadius: '30px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: '6vw'
}
export const transformData = (inputArray, commonData, loginData) => {
  const outputArray = inputArray.map(item => ({
    intDeliveryID: 0,
    intCompanyID: loginData.intCompanyID,
    intBookingID: item.BookingID,
    strReceivedBy: commonData.ReceivedBy,
    strIDProof: commonData.IDProof,
    strOctroiRcptNo: item.OctroiReceiptNo,
    dtOctroiRcptDate: item.OctroiReceiptDate,
    dblOctroiRcptAmt: parseFloat(item.OctroiReceiptAmt),
    strRemarks: commonData.Remarks,
    intUsreID: commonData.intUserID,
    intPaymentType: commonData.PaymentType,
    strPaymentDetails: '',
    dblFreight: parseFloat(item.Freight),
    dblCollectionChg: parseFloat(item.CollectionCharges),
    dblCartage: parseFloat(item.CartageAmount),
    dblDocumentChg: parseFloat(item.DocumentCharges),
    dblInsurance: parseFloat(item.Insurance),
    dblServiceTax: parseFloat(item.ServiceTaxAmount),
    dblTotal: parseFloat(item.NetAmount),
    dblTotalDues: parseFloat(item.TotalDues),
    dblHomeDeliveryChg: parseFloat(item.HomeDeliveryChg),  //input 2 
    dblOutstanding: parseFloat(item.Outstanding),
    dblGoodsValue: parseFloat(item.GoodsValue),
    intReceivingPartyID: commonData.ReceivingPartyID,
    dblAddtitionalDeliveryCartage: parseFloat(item.AdditionalDeliveryCartage), //input 1 
    dblOctroiBrokerageAmt: parseFloat(item.OctroiBrokerageAmt),
    dblDemurrageChg: parseFloat(item.DemurrageChg), //input 4
    intIDProofid: commonData.SenderIDProofID,
    strreceiverimgurl: item.ReceiverImageURL,
    strIDProofimgurl: item.SenderIDProffUrl,
    dblLatitude: 0,
    dblLongitude: 0,
    strDeliverdLocation: "",
    IsDeliverdLocation: 0,
    dblDeliveryGST: parseFloat(item.DeliveryGST), //input 6
    strReceiverContactNo: commonData.RecMobileNo,
    dblExtraHamali: parseFloat(item.ExtraHamli), //input 3
    strVehicleNo: commonData.VehicleNo,
    strReceiverGSTN: item.ReceiverGSTN,
    strGSTPaidBy: item.ServiceTaxPaidBy,
    dblDeliveryDisc: item?.Discount || 0,  //input 5 
    WalletOrderId: 0,
    GSTNState: '',
    DelGSTAmount: parseFloat(item.DeliveryGST),
    IsDeliveryRCM: 0,
    AccountNo: "",
    TransactionID: ""
  }));

  return outputArray;
}

const escapeHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')

const sanitizePdfFileName = (value) => String(value || 'DeliveryTicket').replace(/[\\/:*?"<>|]/g, '-')

const waitForImages = (element) => {
  const images = Array.from(element.querySelectorAll('img'))
  return Promise.all(
    images.map((img) => {
      if (img.complete) return Promise.resolve()
      return new Promise((resolve) => {
        img.onload = resolve
        img.onerror = resolve
      })
    })
  )
}

const printStyles = `
  <style>
    @page { margin: 0; size: auto; }
    html, body {
      margin: 0;
      padding: 0;
      background: #fff;
      color: #000;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    * {
      opacity: 1 !important;
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }
  </style>
`

const pdfRenderStyles = `
  *, *::before, *::after {
    opacity: 1 !important;
    color: #000 !important;
    border-color: #000 !important;
    text-shadow: none !important;
    box-shadow: none !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
    color: #000 !important;
  }
  table, tr, td, th, div, span {
    border-color: #000 !important;
  }
`

const getPrintableHtml = (html) => {
  if (/<html[\s>]/i.test(html)) {
    if (/<head[\s>]/i.test(html)) return html.replace(/<head([^>]*)>/i, `<head$1>${printStyles}`)
    return html.replace(/<html([^>]*)>/i, `<html$1><head>${printStyles}</head>`)
  }

  return `
    <html>
      <head>${printStyles}</head>
      <body>${html}</body>
    </html>
  `
}

export const printHtml = async (html) =>
  new Promise((resolve) => {
    const iframe = document.createElement('iframe')
    iframe.style.position = 'fixed'
    iframe.style.right = '0'
    iframe.style.bottom = '0'
    iframe.style.width = '0'
    iframe.style.height = '0'
    iframe.style.border = '0'
    document.body.appendChild(iframe)

    const frameWindow = iframe.contentWindow
    const frameDocument = iframe.contentDocument || frameWindow.document
    let isCleanedUp = false
    const cleanup = () => {
      if (isCleanedUp) return
      isCleanedUp = true
      if (document.body.contains(iframe)) document.body.removeChild(iframe)
      resolve(true)
    }

    frameDocument.open()
    frameDocument.write(getPrintableHtml(html))
    frameDocument.close()

    setTimeout(async () => {
      await waitForImages(frameDocument.body)
      frameWindow.focus()
      frameWindow.onafterprint = cleanup
      frameWindow.print()
      setTimeout(cleanup, 10000)
    }, 300)
  })

export const getSuccessfulDeliveryPrintList = (bulkResponse, deliveredLrs = []) => {
  const [responses = []] = Array.isArray(bulkResponse) ? bulkResponse : []
  return responses.reduce((printList, response, index) => {
    if (response?.status !== 'Success') return printList

    const selectedLr = deliveredLrs[index] || {}
    const responseData = response?.Data?.Table?.[0] || {}
    const BookingID = response?.BookingID || responseData?.BookingID || selectedLr?.BookingID
    const LRNO = response?.LRNO || responseData?.LRNO || selectedLr?.LRNO

    if (!BookingID && !LRNO) return printList
    return [...printList, { ...selectedLr, ...responseData, BookingID, LRNO }]
  }, [])
}

export const downloadHtmlAsPdf = async (html, fileName, ticketDimension = null, options = {}) => {
  const { preview = false, print = false } = options
  if (print) return await printHtml(html)
  const wrapper = document.createElement('div')
  const [height, width] = ticketDimension || []
  wrapper.style.position = 'fixed'
  wrapper.style.left = '-10000px'
  wrapper.style.top = '0'
  wrapper.style.width = ticketDimension ? `${+width + 5}mm` : '210mm'
  wrapper.style.minHeight = ticketDimension ? `${height}mm` : '297mm'
  wrapper.style.background = '#fff'
  wrapper.innerHTML = html
  const style = document.createElement('style')
  style.innerHTML = pdfRenderStyles
  wrapper.prepend(style)
  document.body.appendChild(wrapper)

  try {
    await waitForImages(wrapper)
    const preferredTarget = wrapper.querySelector('#printBox') || wrapper.querySelector('.printable') || wrapper.firstElementChild || wrapper
    const targetBounds = preferredTarget.getBoundingClientRect()
    const target = targetBounds.width && targetBounds.height ? preferredTarget : wrapper
    const canvas = await html2canvas(target, {
      // const canvas = await html2canvas(wrapper.firstElementChild || wrapper, {
      backgroundColor: '#fff',
      scale: 2,
      useCORS: true,
    })
    const imageData = canvas.toDataURL('image/png')

    if (ticketDimension) {
      // const [height, width] = ticketDimension
      const pdfWidth = +width + 5
      const pdfHeight = +height
      const doc = new jsPDF({
        orientation: pdfWidth > pdfHeight ? 'l' : 'p',
        unit: 'mm',
        format: [pdfWidth, pdfHeight],
      })
      doc.addImage(imageData, 'PNG', 0, 0, pdfWidth, pdfHeight)
      if (preview) return doc.output('bloburl')
      doc.save(`${sanitizePdfFileName(fileName)}.pdf`)
      return true
    }

    const doc = new jsPDF('p', 'mm', 'a4')
    const pageWidth = doc.internal.pageSize.getWidth()
    const pageHeight = doc.internal.pageSize.getHeight()
    const imageHeight = (canvas.height * pageWidth) / canvas.width
    let remainingHeight = imageHeight
    let y = 0

    doc.addImage(imageData, 'PNG', 0, y, pageWidth, imageHeight)
    remainingHeight -= pageHeight

    while (remainingHeight > 0) {
      y -= pageHeight
      doc.addPage()
      doc.addImage(imageData, 'PNG', 0, y, pageWidth, imageHeight)
      remainingHeight -= pageHeight
    }
    if (preview) return doc.output('bloburl')
    doc.save(`${sanitizePdfFileName(fileName)}.pdf`)
    return true
  } finally {
    document.body.removeChild(wrapper)
  }
}

const getTicketLineHtml = (item, ticketData, topDeduct = 0) => {
  if (!item || item.includes('--THERMAL-PRINT-SPLITTER--')) return ''
  if (isTableToken(item)) return getTablePrintHtml(item, ticketData, topDeduct)

  const [, value, left, top, fontSize, v, fontWeight] = item.split('|')
  const displayValue = v === 'V' ? ticketData?.[value?.replaceAll('@', '')] : value
  const whiteSpace = v === 'V' ? 'pre-line' : 'normal'
  const topPos = getNum(top) - (topDeduct || 0)

  return `
    <span style="
      position:absolute;
      font-size:${getNum(fontSize)}pt;
      left:calc(${getNum(left) + 10}px + 2.5mm);
      top:${topPos}px;
      font-weight:${fontWeight == 1 ? 'bold' : 'normal'};
      color:#000;
      font-family:Arial,Helvetica,'Segoe UI',Roboto,sans-serif;
      white-space:${whiteSpace};
    ">${escapeHtml(displayValue)}</span>
  `
}

const getQrAndLogoHtml = async (formatList, ticketData, loginData) => {
  const ticketParams = {
    BookingID: ticketData?.BookingID,
    intUserID: loginData?.intUserID,
  }
  const lrDetailUrl = getTrackingUrl.call(ticketParams)
  const qrDataUrl = await QRCodeGenerator.toDataURL(lrDetailUrl, { margin: 0, width: 256 })

  return formatList
    .map((item) => {
      const [printType, left, top, height, width] = item.split('|')
      if (printType === 'QR') {
        return `<img src="${qrDataUrl}" style="position:absolute;left:${left}px;top:${top}px;height:${height}px;width:${width}px;" />`
      }
      if (printType === 'Logo') {
        return `<img crossorigin="anonymous" src="${ticketData?.LogoURL || ''}" style="position:absolute;left:${left}px;top:${top}px;height:${height}px;width:${width}px;" />`
      }
      return ''
    })
    .join('')
}

export const getTicketHtml = async (ticketData, ticketFormatDetail, loginData) => {
  const ticketDimension = ticketFormatDetail?.TicketDimension?.split(',') || []
  const ticketFormat = filterItemsHiddenByTables(ticketFormatDetail?.TicketFormat?.split('^') || [])
  const qrAndLogoFormat = filterQrLogoHiddenByTables(
    ticketFormatDetail?.QRandLogoFormat?.split('^') || [],
    ticketFormatDetail?.TicketFormat?.split('^') || []
  )
  const qrAndLogoHtml = await getQrAndLogoHtml(qrAndLogoFormat, ticketData, loginData)
  const formatFont = ticketFormatDetail?.FormatFont
    ? `${ticketFormatDetail.FormatFont},Arial,Helvetica,'Segoe UI',Roboto,sans-serif`
    : 'Microsoft Sans Serif,Arial,Helvetica,Segoe UI,Roboto,sans-serif'

  return {
    ticketDimension,
    html: `
      <div style="
        position:relative;
        background:#fff;
        width:${+ticketDimension[1] + 5}mm;
        height:${ticketDimension[0]}mm;
        font-family:${formatFont};
        color:#000;
        overflow:hidden;
      ">
        ${ticketFormat
          .map((item) => getTicketLineHtml(item, ticketData, getTopDeductForItem(item, ticketFormat)))
          .join('')}
        ${qrAndLogoHtml}
      </div>
    `,
  }
}

export const downloadDeliveryTicketPdf = async (item, context, options = {}) => {
  const { intBranchID, loginData } = context
  const printPayload = {
    intBookingID: item?.BookingID,
    intBranchID,
    intUserID: loginData?.intUserID,
    strLRNO: item?.LRNO,
  }
  const printResponse = await PostRequestV2(urls.printDelivery, printPayload)
  const ticketData = printResponse?.status === 'Success' ? printResponse?.Data?.Table?.[0] : null

  if (!ticketData) return false

  const lrNo = ticketData?.LRNO || item?.LRNO

  if (ticketData?.CargoHasBilltyLaserPrint == 1 && ticketData?.BilltyTemplate) {
    return await downloadHtmlAsPdf(ticketData.BilltyTemplate, lrNo, null, options)
    // await downloadHtmlAsPdf(ticketData.BilltyTemplate, lrNo)
    // return true
  }

  const formatResponse = await PostRequestV2(urls.cargoTicketFormat, {
    intTicketFormatID: ticketData?.TicketFormatID || 0,
    intCompanyID: 0,
    strFormatType: ticketData?.FormatTypeCust || 'B',
    intIsDeleted: 0,
  })
  const ticketFormatDetail = formatResponse?.status === 'Success' ? formatResponse?.Data : null

  if (!ticketFormatDetail) return false

  const { html, ticketDimension } = await getTicketHtml(ticketData, ticketFormatDetail, loginData)
  if (!ticketDimension?.[0] || !ticketDimension?.[1]) return false
  return await downloadHtmlAsPdf(html, lrNo, ticketDimension, options)
  // await downloadHtmlAsPdf(html, lrNo, ticketDimension)
  // return true
}

export const DownloadDeliveredTicketPdfs = async (bulkResponse, deliveredLrs, context) => {
  const printList = getSuccessfulDeliveryPrintList(bulkResponse, deliveredLrs)
  if (context?.printSingle && printList.length === 1) {
    return await downloadDeliveryTicketPdf(printList[0], context, { print: true })
  }
  if (context?.previewSingle && printList.length === 1) {
    return await downloadDeliveryTicketPdf(printList[0], context, { preview: true })
  }
  let downloadCount = 0

  for (const item of printList) {
    try {
      const isDownloaded = await downloadDeliveryTicketPdf(item, context)
      if (isDownloaded) downloadCount += 1
    } catch (err) {
      console.log(err)
    }
  }

  return downloadCount
}
export const excelButton = {
  color: '#0086ff'
}

export const getTransferData = (inputArray, commonData) => {
  const outputArray = inputArray.map((data) => ({
    intBranchTransferID: 0,
    intFromCityID: data.CurrentCityID,
    intToCityID: commonData.toCity,
    intFromBranchID: data.CurrentBranchID,
    intToBranchID: commonData.BranchForDelTrans,
    intCompanyID: commonData.intCompanyID,
    strVehicleType: 'SV',
    strVehicleNo: commonData.VehicleNo,
    strTransferReason: commonData.Remarks,
    strRemarks: commonData.Remarks,
    intUserID: commonData.intUserID,
    blnDeliveryTransfer: true,
    intVehicleID: commonData.intVehicleID,
    strBookingIDs: data.BookingID,
    strLRNos: data.LRNO,
    strShortQtys: 0,
    strDamageQtys: 0,
    intDriverID: commonData.driverName,
  }))
  return outputArray
}
export const pancardValidation = (text) => {
  let regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  if (regex.test(text)) {
    return true;
  }
  return false;
}

export function ValidateAadhaar(aadhaar) {
  var expr = /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/;
  if (!expr.test(aadhaar)) {
    return false;
  } else {
    return true
  }
}

// export const calculateFinalAmounts = dataArray => {
//   const updatedArray = dataArray.map(data => {
//     let finalAmount=0
//     if(data?.PaymentType==='ToPayDDDV'||data?.PaymentType==='TOPAY'||data?.PaymentType==='TOPAY(MANUAL)'|| data?.PaymentType==='COD'){
//       finalAmount = +Number(data?.TotalDues)+ +data.AdditionalDeliveryCartage + +data.Deliverychg + +data.ExtraHamli + +data.DemurrageChg + +data.DeliveryGST  - data.Discount
//     }else{
//       finalAmount = +Number(data.AdditionalDeliveryCartage) + +data.Deliverychg + +data.ExtraHamli + +data.DemurrageChg + +data.DeliveryGST  - data.Discount
//     }
//     return {
//       ...data,
//       finalAmount:finalAmount,
//     }
//   });
//   return updatedArray;
// };

export const calculateFinalAmounts = (dataArray) => {
  const updatedArray = dataArray.map(data => ({
    ...data,
    finalAmount: calculateAmount(data)
  }));
  return updatedArray;
};

const calculateAmount = (data) => {
  const {
    PaymentTypeID,
    TotalDues = 0,
    AdditionalDeliveryCartage = 0,
    HomeDeliveryChg = 0,
    ExtraHamli = 0,
    DemurrageChg = 0,
    DeliveryGST = 0,
    Discount = 0
  } = data;

  const totalDuesVal = +TotalDues;
  const additionalDeliveryCartageVal = +AdditionalDeliveryCartage
  const deliveryChgVal = +HomeDeliveryChg
  const extraHamliVal = +ExtraHamli
  const demurrageChgVal = +DemurrageChg
  const deliveryGSTVal = +DeliveryGST
  const discountVal = +Discount

  let finalAmount = additionalDeliveryCartageVal + deliveryChgVal + extraHamliVal + demurrageChgVal + deliveryGSTVal - discountVal
  if ([paytypes.TO_PAY, paytypes.COD, paytypes.TO_PAY_MANUAL, paytypes.TO_PAY_DDDV].includes(PaymentTypeID)) {
    finalAmount = totalDuesVal + finalAmount
  }

  return finalAmount;
};